import { Body, Header } from "components";
import ThumbnailCardViewGrid from "components/ThumbnailCardViewGrid";
import Section from "components/layout/Section";
import { products } from "module/products";
import { ProductType } from "module/types";
import { setPageIndex } from "module/reducers/pageIndexReducer";
import SocketService from "network/SocketService";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { logAnalyticsEvent } from "api/firebaseManager";
import Footer from "components/layout/Footer";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import FilterButtons from "components/FilterButtons";
import "sass/views/HomeContainer.scss";

function HomeContainer() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [selectedTypes, setSelectedTypes] = useState<ProductType[]>([]);

  useEffect(() => {
    SocketService.getInstance().disconnect();
    dispatch(setPageIndex(0));

    // 홈 진입 이벤트 로깅
    logAnalyticsEvent("page_view", {
      page_name: "home",
    });
  }, [dispatch]);

  const handleProductClick = (id: number, title: string) => {
    logAnalyticsEvent("product_click", {
      product_id: id,
      product_title: title,
    });
  };

  const handleTypeToggle = (type: ProductType) => {
    setSelectedTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  // 필터링된 제품 리스트 계산
  const filteredProducts =
    selectedTypes.length === 0
      ? products
      : products.filter((product) => selectedTypes.includes(product.type));

  // 구조화된 데이터
  const websiteData = {
    name: "Lingple",
    description:
      i18n.language === "ko"
        ? "다양한 멀티플레이 게임과 오프라인 이벤트 도구들을 통해 모임을 더욱 알차게 만들어보세요."
        : "Create more meaningful gatherings with various multi-player games and offline event tools.",
    url: window.location.origin,
    inLanguage: i18n.language,
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${window.location.origin}/search?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <SEO />
      <StructuredData type="website" data={websiteData} />
      <Header />
      <Body indexScroll={null}>
        <div className="home-container horizontal-layout space-gray-theme">
          <Section isFirst name={"home"}>
            <div className="products-container">
              {/* <div className="text-left mb-8">
                <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">
                  {t("services")}
                </h1>
                <p className="text-xl font-semibold">{t("servicesSubtitle")}</p>
              </div> */}
              <FilterButtons
                selectedTypes={selectedTypes}
                onToggle={handleTypeToggle}
              />
              <ThumbnailCardViewGrid
                items={filteredProducts}
                onItemClick={handleProductClick}
              />
            </div>
          </Section>
        </div>
      </Body>
      <Footer />
    </>
  );
}

export default HomeContainer;
